export const combineClassName = (...classNames) => {
  return classNames.join(" ");
};
